export { SERIE_FORMAT as METRIC_FORMAT } from "@tokenterminal/core/feature/chart/tt-ui-chart/ChartOptions"
